/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-19 17:44:00
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-10-16 10:18:33
 */
import { getDictItemAllList } from "./api-basic";
import config from "@/config/config";
/**
 * 获取字典用的 KEYk
 */
export const optionKey = {
    auxPowerList: "104",
    devTypeList: "102",
    innerIdList: "185",
    pushStatusList: "103",
    httpList: "107",
    getList: "108",
    spearTypeList: "1018",
    clientList: "1017",
    isShowObj: "1019",
    networkObj: "1020",
    autotrophyObj: "156",
    staStatusObj: "153",
    csTypeObj: "154",
    orderStatusObj: "155",
    orderTypeObj: "12377",
    tagObj: "1016",
    suppoertOrderObj: "1021",
    allDayDisparkObj: "1022",
    freeParkObj: "1023",
    paymentObj: "1024",
    messageTypeList: "1030",
    cardStatusList: "159",
    provideList: "160",
    cardStatusObj: "1033",
    roleTypeObj: "1069",
    queryTypeList: "1076",
    netDriectionObj: "12367",
    netTypeObj: "12368",
    netStatus: "12366",
    defaultAbnormalOrderList: "12374",
    applyStatusList: "12373 ",
    userTypeObj: "12365",
    noticeStatusObj: "12382",
    simCardFlowList: "12383",
    noticeTypeObj: "12363",
    objectTypeObjChecking: "12379",
    couponTypeObj: "12384",
    applyStatusObj: "12386",
    campaignTypeObj: "12388",
    campaignStatusObj: "12389",
    chargeModeObj: "12391",
    dealTypeObj: "12392",
    staApplyStatusObj: "12393",
    invoiceTypeList: "12407",
    orderStatusList: "12408",
    orderStatusTodayList: "12409",
    invoiceTypeObj: "12413",
    alarmLevel: "12410",
    alarmStatus: "12455",
    alarmType: "12456",
    chargingModeObj: "12511",
    operRoleObj: "12403",
    applyStatusType: "12412",
    startModeObj: "12534",
    minDurationObj: "12522",
    reserveOrderStatusObj: "12516",
    durationRangeObj: "12521",
    stopReasonObj: "12520",
    auditResultObj: "12519",
    abnormalTypeObj: "12524",
    chargeUserTypeObj: "12512",
};
/**
 * @description: 获取字典信息 typeIds是数组, 里面是 optionKey 对应的ID
 * @param {typeIds}
 * @return: Promise
 */
export const getOptionList = async (typeIds) => {
    const ret = await getDictItemAllList({
        typeIdList: typeIds,
    });
    return new Promise((resolve) => {
        if (ret.status === config.apiStatus) {
            const list = ret.data;
            const obj = {};
            const language = localStorage.getItem("language") || "";
            typeIds.map((typeId) => {
                list.map((item) => {
                    if (item.typePkId == typeId) {
                        if (!obj[typeId]) {
                            obj[typeId] = [];
                        }
                        const value = language == "en-US" && item.englishName != undefined
                            ? item.englishName
                            : item.itemValue;
                        item.label = value;
                        item.itemValue = value;
                        item.value = item.itemKey;
                        obj[typeId].push(item);
                    }
                });
            });
            resolve(obj);
        }
    });
};
